import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ErrorCode } from 'mbs-ui-shared@constants/errorCodes';
import { EMPTY, Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable()
export class RedirectInterceptor implements HttpInterceptor {
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        const errorResponse = error.error;
        const redirectUrl = errorResponse?.detail;

        if ((errorResponse?.typeCode && Number(errorResponse.typeCode) === ErrorCode.Redirect) && error.status === 400 && redirectUrl) {
          window.location.href = redirectUrl;

          return EMPTY;
        }

        return throwError(() => error);
      })
    );
  }
}
